var render, staticRenderFns
import script from "./reverbBoundList.vue?vue&type=script&lang=js"
export * from "./reverbBoundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dfba18",
  null
  
)

export default component.exports